var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 35,
    fill: "none",
    viewBox: "0 0 42 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#D9D9D9",
    strokeWidth: 1.2,
    d: "M67.667-38.5h-93.334C-30.82-38.5-35-34.321-35-29.167v93.334c0 5.154 4.179 9.333 9.333 9.333h93.334C72.82 73.5 77 69.321 77 64.167v-93.334c0-5.154-4.179-9.333-9.333-9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M15.909 1.07l-.18.012c-.356.05-.677.249-.879.55l-3.019 4.493H5.727c-2.577 0-4.666 2.075-4.666 4.634v18.537c0 2.56 2.089 4.635 4.666 4.635h30.546c2.577 0 4.666-2.075 4.666-4.635V10.76l-.008-.282c-.147-2.428-2.176-4.352-4.658-4.352h-6.106L27.15 1.632c-.236-.351-.634-.563-1.06-.563H15.91zm.68 2.527h8.82l3.017 4.493c.236.352.633.563 1.059.563h6.788c1.171 0 2.12.943 2.12 2.106v18.537c0 1.164-.949 2.107-2.12 2.107H5.727c-1.171 0-2.121-.943-2.121-2.107V10.76c0-1.163.95-2.106 2.121-2.106h6.788l.18-.013c.356-.05.677-.249.88-.55l3.015-4.493z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M21 11.18c-4.452 0-8.06 3.584-8.06 8.005 0 4.421 3.608 8.005 8.06 8.005s8.06-3.584 8.06-8.005c0-4.42-3.608-8.004-8.06-8.004zm0 2.528c3.046 0 5.515 2.452 5.515 5.477 0 3.025-2.47 5.477-5.515 5.477-3.046 0-5.515-2.452-5.515-5.477 0-3.024 2.469-5.477 5.515-5.477z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H42V35H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6ac08b5ec5679ca3a32e952311f3c925.svg";
export { ForwardRef as ReactComponent };